import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: " Foundations of Psychology & Human Behavior",
    description:
      "Introduction to Psychology, Its branches & applications, History & evolution of psychological science, Understanding behavior emotions & mental processes, Nature vs nurture debate, Psychology in everyday life education and workplace",
  },
  {
    title: "Biological Psychology & Brain Functioning",
    description:
      "Structure & function of the nervous system, Brain regions & their role in behavior, Neurotransmitters & hormones, Sensation perception & cognitive processing, How the brain influences thoughts & actions",
  },
  {
    title: "Cognitive Psychology & Mental Processes",
    description:
      "Learning memory & information processing, Attention perception & problem-solving, Language development & thought patterns, Decision-making mechanisms, Improving cognitive skills through psychology",
  },
  {
    title: "Developmental Psychology Across Lifespan",
    description:
      "Human development: childhood → adulthood → aging, Emotional social & cognitive development, Attachment theory & parenting styles, Personality formation during growth, Changes in behavior across life stages",
  },
  {
    title: "Personality Psychology & Individual Differences",
    description:
      "Major personality theories: Freud Jung Big Five, Traits motivations & internal drives, Self-concept identity & self-esteem, Assessment tools & personality tests, Understanding strengths & behavioral patterns",
  },
  {
    title: "Social Psychology & Human Relationships",
    description:
      "Group behavior & social influence, Attitudes stereotypes & prejudice, Communication & persuasion techniques, Leadership teamwork & conflict resolution, Understanding cultural and social interactions",
  },
  {
    title: "Abnormal Psychology & Mental Health Disorders",
    description:
      "Anxiety depression OCD bipolar PTSD phobias, Causes symptoms & diagnosis, Myths & stigma around mental health, Early warning signs & risk factors, Understanding psychological suffering compassionately",
  },
  {
    title: "Counseling Psychology & Emotional Well-Being",
    description:
      "Basics of counseling & talk therapy, Building empathy active listening & rapport, Stress management mindfulness & coping strategies, Crisis handling & emotional support techniques, When to refer someone for professional help",
  },
  {
    title: "Research Methodologies & Psychological Testing",
    description:
      "Scientific methods in psychology, Surveys experiments & observation techniques, Psychometric tests & behavioral assessments, Ethics in psychological research, Analyzing data & interpreting findings",
  },
  {
    title: "Capstone Psychology Project & Career Launchpad",
    description:
      "Conducting a behavioral or research-based study, Presenting findings through reports & case studies, Portfolio creation for psychology-related roles, Resume & LinkedIn setup, Interview prep for roles: Counselor Assistant HR Behavior Analyst Mental Health Support Worker Psychology Intern",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
